export default __webpack_public_path__ + "static/media/inventory_icon.b9935e0a.svg";